import {customElement, property} from 'lit/decorators.js';
import {html, LitElement} from 'lit';
import {style} from '@/components/copy-link/copy-link.styles';
import {SbkLabelMixin} from "@/components/label/label-mixin";
import {labelStyles} from "@/components/label/label.styles";
import {inputStyles} from "@/components/input/input.styles";
import {SbkModal} from "@/components/modal/modal";
import {buttonOnDarkStyles} from "@/components/button/button--onDark.styles";

@customElement('sbk-copy-link')
export class SbkCopyLink extends SbkLabelMixin(LitElement) {

    @property()
    value: string = ''

    @property({attribute: 'modal-title'})
    modalTitle: string = ''

    @property({attribute: 'modal-text'})
    modalText: string = ''

    @property({attribute: 'button-label'})
    buttonLabel: string = ''


    static get styles() {
        return [
            labelStyles,
            inputStyles,
            style,
            buttonOnDarkStyles
        ];
    }

    render() {
        return html`
            <div class="copy-link">
                ${this.labelTemplate("copyLinkInput", false, false)}
                <div class="copy-link__wrapper">
                    <input
                        id="copyLinkInput"
                        class="input"
                        type="search"
                        .value=${this.value}
                        autocomplete="off"
                        readonly
                    />
                    <button @click=${this._copyLink} class="copy-link-button">
                        ${this.buttonLabel}
                    </button>
                </div>
                <sbk-modal id="copy-link-modal" icon="success" heading=${this.modalTitle}>
                    <p>${this.modalText}</p>
                </sbk-modal>
            </div>
        `;
    }

    _copyLink() {
        navigator.clipboard.writeText(this.value);
        const modal: SbkModal | null | undefined = this.shadowRoot?.querySelector('sbk-modal')
        if (modal) {
            const dialog: HTMLDialogElement | null = modal.renderRoot.querySelector('dialog');
            dialog?.showModal()
        }
    }
}
